<!--SECTION-->
<section data-testid="push-editorial-selection" hBindSPANavigationForCTA class="block-edito-push-editorial-selection">
    <ul>
        @for (blockEdito of editorialSelection.editorialBlocks; track blockEdito) {
            <li
                [attr.tabindex]="!blockEdito.media?.videoUrl ? '0' : ''"
                [ngClass]="{ 'editorial-selection-link-block': !blockEdito.media?.videoUrl }">
                <!--Media Block-->
                @if (blockEdito.media) {
                    <h-media-cta
                        class="editorial-selection-media"
                        [media]="blockEdito.media"
                        [mediaOptions]="mediaOptions"
                        [preloadPoster]="shouldPreloadMedia"></h-media-cta>
                }
                <!--Block Texte of Editorial Selection-->
                <div
                    [ngClass]="{ 'editorial-selection-link-block': blockEdito.media?.videoUrl }"
                    [attr.tabindex]="blockEdito.media?.videoUrl ? '0' : ''"
                    class="editorial-selection-text">
                    @if (blockEdito.title) {
                        <h3>
                            @if (blockEdito.token) {
                                <a
                                    data-cta-spa
                                    hBindSPANavigationForCTA
                                    tabindex="-1"
                                    class="editorial-title"
                                    [attr.aria-label]="blockEdito?.title"
                                    [attr.href]="setToken(blockEdito)">
                                    {{ blockEdito.title }}
                                </a>
                            }
                        </h3>
                    }
                    @if (blockEdito.title && !blockEdito.token) {
                        <h3>{{ blockEdito.title }}</h3>
                    }
                    @if (blockEdito.text) {
                        <div [innerHtml]="blockEdito.text | trustHtml" class="editorial-selection-text"></div>
                    }

                    <div class="editorial-block-intro" [attr.aria-hidden]="blockEdito.title ? 'true' : 'false'">
                        @if (blockEdito.token) {
                            <a
                                data-cta-spa
                                tabindex="-1"
                                hBindSPANavigationForCTA
                                [attr.href]="setToken(blockEdito)"
                                [attr.aria-label]="blockEdito.token.text">
                                @if (!editorialSelection.hideCTA) {
                                    <span>{{ blockEdito.token.text }}</span>
                                }
                            </a>
                        }
                    </div>
                </div>
            </li>
        }
    </ul>
</section>
